import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Container, CssBaseline, Switch, Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import Home from './pages/Home';
import ContestPage from './pages/ContestPage';
import AddContestEntry from './components/AddContestEntry';
import AddParticipant from './components/AddParticipant';
import UpdateParticipant from './components/UpdateParticipant';
import TelegramWebAppSubmission from './telegram/TelegramWebAppSubmission';
import ManageSubmissions from './telegram/ManageSubmissions';
import TelegramWebUserProfile from './telegram/TelegramWebUserProfile';
import ParticipantMasterPage from './pages/ParticipantMasterPage';
import { theme } from './theme';

const App: React.FC = () => {
  const tg = (window as any)?.Telegram?.WebApp;

  // Load the saved theme from localStorage or fallback to Telegram's color scheme or 'light'
  const [themeMode, setThemeMode] = useState<'light' | 'dark'>(
      localStorage.getItem('themeMode') as 'light' | 'dark' || tg?.colorScheme || 'light'
  );

  // Listen for Telegram theme changes
  useEffect(() => {
    if (tg) {
      tg.onEvent('themeChanged', () => {
        const newTheme = tg?.colorScheme || 'light';
        setThemeMode(newTheme);
        localStorage.setItem('themeMode', newTheme); // Save Telegram theme to localStorage
      });
    }
  }, [tg]);

  // Toggle theme manually and save to localStorage
  const handleThemeToggle = () => {
    setThemeMode((prev) => {
      const newTheme = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem('themeMode', newTheme); // Save the theme to localStorage
      return newTheme;
    });
  };

  return (
      <ThemeProvider theme={theme(themeMode)}>
        <CssBaseline />
        <Router basename="/zaruba">
          <AppBar position="static">
            <Toolbar>
              <Link to="/" style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%',}} />
              <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {/* Image in front of the title */}
                <img
                    src={`${process.env.PUBLIC_URL}/photoskiff.png`}
                    alt="photoskiff"
                    style={{ width: '40px', height: '40px', marginRight: '10px' }}
                />
                {/* Title without link styling */}
                <Typography variant="h6" sx={{ textAlign: 'center' }}>
                  Зарубы Фотоскифа
                </Typography>
              </Box>
              {/* Theme Toggle Switch */}
              <Switch
                  checked={themeMode === 'dark'}
                  onChange={handleThemeToggle}
                  color="default"
                  inputProps={{ 'aria-label': 'theme toggle' }}
                  sx={{ ml: 'auto' }}
              />
            </Toolbar>
          </AppBar>
          <Container style={{ marginTop: '2rem' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contest/:contestId" element={<ContestPage />} />
              <Route path="/participant/:participantId" element={<ParticipantMasterPage />} />
              <Route path="/contest/:contestId/add-entry" element={<AddContestEntry />} />
              <Route path="/add-participant" element={<AddParticipant />} />
              <Route path="/update-participant" element={<UpdateParticipant />} />
              <Route path="/telegram/submit-result" element={<TelegramWebAppSubmission />} />
              <Route path="/telegram/user-profile" element={<TelegramWebUserProfile />} />
              <Route path="/admin/manage-submissions" element={<ManageSubmissions />} />
            </Routes>
          </Container>
        </Router>
      </ThemeProvider>
  );
};

export default App;
